<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="period of periods"
      :value="period"
      :key="period">
        {{ period }}
    </option>
  </select>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Periods, periodType } from '@/store/common.types'

@Component
export default class SelectPeriodInput extends Vue {
  @Prop() value!: periodType

  private periods = Periods

  private get selected(): periodType {
    return this.value
  }

  private set selected(period: periodType) {
    this.$emit('input', period)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
